const SignupPrefrencesData = {
  subscriberRoleId: {
    value: "",
    type: "select",
    label: "What do you do?",
    name: "subscriber",
    errorMsg: "Please select an option",
    validation: {
      require: true
    },
    valid: true
  },
  subscriberInvestDomainId: {
    value: "",
    type: "select",
    name: "Domain",
    label: "Where do you mainly invest?",
    errorMsg: "Please select an option",
    validation: {
      require: true
    },
    valid: true
  },
  privacyTerms: {
    value: false,
    type: "checkbox",
    name: "privacyTerms",
    id: "privacy_term",
    json: true,
    noIteration: true,
    errorMsg:
      "You must review and agree to the Privacy Policy and Terms of Use",
    validation: {
      checkbox: true
    }
  },
  isSubscribedForNewsLetter: {
    value: false,
    type: "checkbox",
    name: "isSubscribedForNewsLetter",
    id: "newsletter",
    noIteration: true,
    errorMsg: "",
    validation: {}
  },
  loggedIn: {
    value: true,
    type: "checkbox",
    name: "loggedIn",
    json: true,
    id: "logged",
    noIteration: true,
    errorMsg: "",
    validation: {}
  }
};

export default SignupPrefrencesData;
